import React, { Component } from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import bannerImage from "../../Images/about/codeofconductbanner.webp";

const CocHostel = () => {
  return (
    <>
      <title>Hostel Code of Conduct – ISBM University | Rules & Discipline</title>
      <meta
        name="description"
        content="Discover ISBM University’s Hostel Code of Conduct, ensuring a safe, respectful, and disciplined living environment for students on campus."
      />
      <Topnav />
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="container-xxl">
            <div className="section-hero-content">
              <h1> CODE OF CONDUCT FOR THE BOARDERS OF HOSTEL</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                    Home
                  </a>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Code Of Conduct Hostel
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className=" ptb-50">
        <div className="container-xxl">
          <Row className="justify-content-center">
            <Col lg={10}>
              <div className="coc-card shadow p-4 p-lg-5">
                <div className="intro-section mb-5">
                  <p className="lead">
                    The boarders of the hostels are expected to uphold high
                    standards of ethical and moral behavior. The following code
                    of conduct is outlined for them.
                  </p>
                </div>

                {/* General Conduct Section */}
                <div className="conduct-section mb-5">
                  <h3 className="fw-bold text-blue mb-4">General Conduct</h3>

                  <div className="conduct-category mb-4">
                    <h4 className="category-title">
                      <i className="ti ti-users me-2 text-blue"></i>
                      Respect for Others
                    </h4>
                    <ul className="conduct-items">
                      <li>
                        Treat all residents, staff, and visitors with respect,
                        kindness, and courtesy.
                      </li>
                      <li>
                        Avoid engaging in behavior that may cause harm,
                        discomfort, or distress to others.
                      </li>
                      <li>
                        Respect the privacy and personal space of fellow
                        residents.
                      </li>
                    </ul>
                  </div>

                  <div className="conduct-category mb-4">
                    <h4 className="category-title">
                      <i className="ti ti-volume-off me-2 text-blue"></i>
                      Quiet Hours
                    </h4>
                    <ul className="conduct-items">
                      <li>
                        Quiet hours are enforced from 9:30 PM to 7:00 AM every
                        day.
                      </li>
                      <li>
                        Keep noise levels to a minimum during quiet hours to
                        ensure a healthy environment for studying and rest.
                      </li>
                    </ul>
                  </div>

                  <div className="conduct-category mb-4">
                    <h4 className="category-title">
                      <i className="ti ti-home me-2 text-blue"></i>
                      Cleanliness
                    </h4>
                    <ul className="conduct-items">
                      <li>
                        Keep your living space clean and tidy at all times.
                      </li>
                      <li>
                        Dispose of garbage properly and follow recycling
                        guidelines.
                      </li>
                      <li>
                        Report any maintenance issues promptly to the hostel
                        admin or warden.
                      </li>
                    </ul>
                  </div>

                  <div className="conduct-category mb-4">
                    <h4 className="category-title">
                      <i className="ti ti-shield-lock me-2 text-blue"></i>
                      Safety and Security
                    </h4>
                    <ul className="conduct-items">
                      <li>
                        Do not compromise the safety and security of yourself or
                        others.
                      </li>
                      <li>
                        Always lock your room when leaving and do not prop doors
                        open.
                      </li>
                      <li>
                        Do not allow unauthorized individuals to enter the
                        hostel premises.
                      </li>
                    </ul>
                  </div>

                  <div className="conduct-category mb-4">
                    <h4 className="category-title">
                      <i className="ti ti-pill me-2 text-blue"></i>
                      Use of Alcohol and Toxic Substances
                    </h4>
                    <ul className="conduct-items">
                      <li>
                        The consumption of alcohol and use of any illegal toxic
                        substances are strictly prohibited in the hostel.
                      </li>
                      <li>
                        Do not bring or store alcohol or any illegal toxic
                        substances on hostel premises.
                      </li>
                    </ul>
                  </div>

                  <div className="conduct-category mb-4">
                    <h4 className="category-title">
                      <i className="ti ti-smoking me-2 text-blue"></i>
                      Smoking
                    </h4>
                    <ul className="conduct-items">
                      <li>
                        Smoking is strictly prohibited within the hostel
                        building, including individual rooms.
                      </li>
                    </ul>
                  </div>

                  <div className="conduct-category mb-4">
                    <h4 className="category-title">
                      <i className="ti ti-school me-2 text-blue"></i>
                      Compliance with University Policies
                    </h4>
                    <ul className="conduct-items">
                      <li>
                        Adhere to all university policies and regulations,
                        including those related to conduct, academic integrity,
                        and proper use of facilities.
                      </li>
                    </ul>
                  </div>

                  <div className="conduct-category">
                    <h4 className="category-title">
                      <i className="ti ti-alert-triangle me-2 text-blue"></i>
                      Disciplinary Action
                    </h4>
                    <ul className="conduct-items">
                      <li>
                        Violation of the hostel code of conduct will result in
                        disciplinary action, including warnings, fines,
                        suspension of hostel privileges, or expulsion from the
                        hostel.
                      </li>
                      <li>
                        Serious or repeated violations may also result in
                        disciplinary action by the university.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default CocHostel;
